import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'
import { ReferenceTypeComponent } from '../../helpers/reference-type-component'

import { OpDescr } from '../core/op-descr'
import { OpDashboardGroup } from './op-dashboard-group'
import { OpEnumObject } from './op-enum-object'
import { OpLegendItem, OpMarker, OpPolygon, OpRange } from './op-map-area'

export class OpDashboardControl {
    //Properties
    public idType: number
    public class: Enums.DashboardItemClass
    public procedure: string
    public script: string
    public referenceType: Enums.ReferenceType
    public indexNbr: number
    public width: number
    public isAlarm: boolean
    public isTemplate: boolean
    public module: Enums.Module
    public referencecData: any[]
    public opState: Enums.OpChangeState
    public isCustomizable: boolean
    public databaseType: Enums.DatabaseType
    public configurationSourceLevel: Enums.ReferenceType
    public correlationType: Enums.DashboardCorrelationType
    public fontColor: string

    //Properties end

    //NavigationProperties
    public type: OpDescr
    public group: OpDashboardGroup
    //NavigationProperties end

    constructor(opObj: any = null) {
        if (opObj) {
            this.class = opObj.Class
            this.procedure = opObj.Procedure
            this.script = opObj.Script
            this.referenceType = opObj.ReferenceType
            this.indexNbr = opObj.IndexNbr
            this.width = opObj.Width
            this.isAlarm = opObj.IsAlarm
            this.isTemplate = opObj.IsTemplate
            this.module = opObj.Module
            this.opState = opObj.OpState
            this.isCustomizable = opObj.IsCustomizable
            this.databaseType = opObj.DatabaseType
            this.configurationSourceLevel = opObj.ConfigurationSourceLevel
            this.correlationType = opObj.CorrelationType
            this.fontColor = opObj.FontColor

            this.type = new OpDescr(opObj.Type)
            this.group = new OpDashboardGroup(opObj.Group)

            this.idType = this.type == null ? 0 : this.type.idDescr

            //this.referencecData = opObj.ReferenceData
            if (opObj.ReferenceData) {
                this.referencecData = (<any[]>opObj.ReferenceData).map(r => { return ReferenceTypeComponent.createReferenceObject(this.referenceType, r) })
            }
        }
    }



}